<template>
  <div class="notification-manager">
        <div :class="['notification', notification.type]" v-for="notification in notifications" :key="notification.id" @click="removeNotification(notification.id)">
            <div class="notification-content">
                <div class="notification-title">{{ notification.title }}</div>
                <div class="notification-message">{{ notification.message }}</div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            notifications: []
        }
    },
    methods: {
        addNotification(notification) {

            if (!notification.type || !notification.title || !notification.message, !notification.duration) {
                throw new Error('Notification must have a type, title and message');
            }

            notification.id = Math.random().toString(36).substr(2, 9);

            this.notifications.push(notification);
            setTimeout(() => {
                this.removeNotification(notification.id);
            }, notification.duration);
        },
        removeNotification(id) {
            this.notifications = this.notifications.filter(notification => notification.id !== id);
        },
    },
    created() {
        this.notificationController.initialize(this);
    }
}
</script>

<style scoped>

.notification-manager {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.notification {
  display: flex;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  animation: slideIn 0.5s;
}

.notification-message {
  font-size: 14px;
}

@keyframes slideIn {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.notification.success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
}

.notification.info {
  background-color: rgb(220, 202, 227);
  border: 1px solid rgb(203, 181, 212);
}

.notification.error {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.notification-content {
  flex: 1;
}

.notification-title {
  font-weight: bold;
}

</style>


// WEBPACK FOOTER //
// src/components/NotificationManager.vue